import { Moon, Sun, DiamondsFour } from "@phosphor-icons/react";
import { useTheme } from "../context/ThemeContext";

const NEXT_LABEL = { light: "Dark", dark: "Premium", premium: "Light" };
const CURRENT_ICON = { light: Moon, dark: DiamondsFour, premium: Sun };

export default function ThemeToggle() {
  const { theme, cycleTheme } = useTheme();
  const Icon = CURRENT_ICON[theme] || Moon;
  return (
    <button
      type="button"
      onClick={cycleTheme}
      data-testid="theme-toggle"
      aria-label={`Switch to ${NEXT_LABEL[theme]} theme`}
      title={`Current: ${theme} · Switch to ${NEXT_LABEL[theme]}`}
      className="theme-toggle inline-flex items-center rounded-none h-11 bg-zinc-900 hover:bg-zinc-800 text-white font-mono uppercase tracking-widest text-xs px-5 shadow-brutal-sm"
    >
      <Icon size={14} weight="bold" className="mr-2" />
      {NEXT_LABEL[theme]}
    </button>
  );
}
